var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIconButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#604099"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1298 21.2866H22.7132V14.8699C22.7132 14.4779 22.3919 14.1566 21.9998 14.1566C21.6078 14.1566 21.2865 14.4779 21.2865 14.8699V21.2866H14.8698C14.4778 21.2866 14.1565 21.6079 14.1565 21.9999C14.1565 22.3919 14.4778 22.7132 14.8698 22.7132H21.2865V29.1299C21.2865 29.5219 21.6078 29.8432 21.9998 29.8432C22.3919 29.8432 22.7132 29.5219 22.7132 29.1299V22.7132H29.1298C29.5219 22.7132 29.8432 22.3919 29.8432 21.9999C29.8432 21.6079 29.5219 21.2866 29.1298 21.2866Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIconButton);
export default __webpack_public_path__ + "static/media/plus-icon-button.6460d8525571ac305c435746293789bc.svg";
export { ForwardRef as ReactComponent };